export const isCategoryRoute = (path, categories) => {
  const strippedPath = path?.replace(/(^\/|\/$)/g, '');
  const category = strippedPath && categories && categories[strippedPath];
  return !!category;
};
